<template>
  <div>
    <div>
      <OrderListCommon :status="status" @listt="listt" :urlT="urlT"></OrderListCommon>
    </div>
  </div>
</template>

<script>
import OrderListCommon from "../common/OrderListCommon";
export default {
  created() {
    this.$emit("Active", 4);
  },
  data() {
    return {
      status: 100,
      sendList: [],
      urlT: "/Particular/particularDefeated"
    };
  },
  methods: {
    listt(listt) {
      this.sendList = listt;
      this.$emit("list", this.sendList);
    }
  },
  components: {
    OrderListCommon
  }
};
</script>

<style scoped>
</style>